export default __webpack_public_path__ + "static/media/bg8.8ac2e483.png";